import { isDevMode } from '@angular/core';

/**
 * Original console methods captured before production muting,
 * so debug logging (environment.debugLog) still works in prod builds.
 * เก็บ console ตัวจริงไว้ก่อนถูกปิดใน production
 */
export const nativeConsole = {
  log: console.log.bind(console),
  groupCollapsed: console.groupCollapsed.bind(console),
  groupEnd: console.groupEnd.bind(console),
};

/**
 * Mute noisy console methods in production builds.
 * Keeps warn/error so real failures still surface.
 */
export function disableConsoleInProduction(): void {
  if (isDevMode()) {
    return;
  }

  const noop = (): void => undefined;
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}
